// extracted by mini-css-extract-plugin
module.exports = {"header":"Table_header__F6xhW","container":"Table_container__1ARI1","tableContainer":"Table_tableContainer__rOlYa","table":"Table_table__3qmb0"};